<template>
  <form class="form" method="post">

    <div id="appClientCreateVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <h2>Ajouter un client</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Sexe*</p>
            <p class="appLabelStyle1">Nom*</p>
            <p class="appLabelStyle1">Prénom*</p>
            <p class="appLabelStyle1">Naissance</p>
            <p class="appLabelStyle1">Adresse</p>
            <p class="appLabelStyle1">Code postal</p>
            <p class="appLabelStyle1">Ville</p>
            <p class="appLabelStyle1">Téléphone</p>
            <p class="appLabelStyle1">Email</p>
            <p class="appLabelStyle1">Notes</p>
          </div>
          <div class="appGroupOfInput">
            <select v-model="sexe" type="select" name="sexe" class="appInputStyle1" placeholder="Femme/Homme/Enfant">
              <option valeur="femme">Femme</option>
              <option valeur="homme">Homme</option>
            </select>
            <input v-model="firstname" type="string" name="firstname" class="appInputStyle1" placeholder="Nom de famille">
            <input v-model="lastname" type="string" name="lastname" class="appInputStyle1" placeholder="Prénom">
            <input v-model="birthdate" type="date" name="birthdate" class="appInputStyle1" placeholder="01/01/2000">
            <input v-model="address" type="string" name="address" class="appInputStyle2" placeholder="Saisir l'adresse">
            <input v-model="cp" type="string" name="cp" class="appInputStyle1" placeholder="88000,...">
            <input v-model="city" type="string" name="City" class="appInputStyle1" placeholder="Golbey">
            <input v-model="phone" type="string" name="phone" class="appInputStyle1" placeholder="06 .. .. .. ..">
            <input v-model="mail" type="mail" name="mail" class="appInputStyle2" placeholder="Saisir un email valide">
            <input v-model="notes" type="string" name="notes" class="appInputStyle1" placeholder="Saisir une note">
          </div>
        </div>
      </div>
      <button @click.prevent="createClient()" type="submit" class="appButtonModel2">Valider</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'ClientCreate',
  data () {
    return {
      sexe: '',
      firstname: '',
      lastname: '',
      birthdate: '',
      address: '',
      cp: '',
      city: '',
      phone: '',
      mail: '',
      notes: '',
      errorMsg: ''
    }
  },
  methods: {
    createClient () {
      if (this.sexe !== null || this.firstname !== null || this.lastname !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        axios
          .post('https://privilegia.fr/api/clients',
            {
              'sexe': this.sexe,
              'firstname': this.firstname.toUpperCase(),
              'lastname': this.lastname,
              'birthdate': this.birthdate,
              'address': this.address,
              'cp': this.cp,
              'city': this.city,
              'phone': this.phone,
              'mail': this.mail,
              'notes': this.notes,
              'technicalsDatas': []
            }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
          .then((response) => {
            window.alert('Nouveau client ajouté')
            this.$router.push('/App/Clients')
          })
          .catch((error) => {
            this.errorMsg = 'Merci de renseigner au minimum le sexe, nom et prénom'
            console.log(error.response.data)
          })
        // Si des champs sont vides
      } else {
        this.errorMsg = 'Merci de renseigner au minimum le sexe, nom et prénom'
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppClientsCreate.vue